function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { $getSelection, $isRangeSelection, FORMAT_TEXT_COMMAND, SELECTION_CHANGE_COMMAND } from 'lexical';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { mergeRegister } from '@lexical/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
var LowPriority = 1;
export default function ToolbarPlugin() {
  var _useLexicalComposerCo = useLexicalComposerContext(),
    _useLexicalComposerCo2 = _slicedToArray(_useLexicalComposerCo, 1),
    editor = _useLexicalComposerCo2[0];
  var toolbarRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isBold = _useState2[0],
    setIsBold = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isItalic = _useState4[0],
    setIsItalic = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isUnderline = _useState6[0],
    setIsUnderline = _useState6[1];
  var updateToolbar = useCallback(function () {
    var selection = $getSelection();
    if ($isRangeSelection(selection)) {
      // Update text format
      setIsBold(selection.hasFormat('bold'));
      setIsItalic(selection.hasFormat('italic'));
      setIsUnderline(selection.hasFormat('underline'));
    }
  }, []);
  useEffect(function () {
    return mergeRegister(editor.registerUpdateListener(function (_ref) {
      var editorState = _ref.editorState;
      editorState.read(function () {
        updateToolbar();
      });
    }), editor.registerCommand(SELECTION_CHANGE_COMMAND, function () {
      updateToolbar();
      return false;
    }, LowPriority));
  }, [editor, updateToolbar]);
  return /*#__PURE__*/React.createElement("div", {
    className: "toolbar",
    ref: toolbarRef
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold');
    },
    className: "btn btn-outline-secondary border-0 toolbar-item spaced ".concat(isBold ? 'active' : ''),
    "aria-label": "Format Bold"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-bold"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'italic');
    },
    className: "btn btn-outline-secondary border-0 toolbar-item spaced ".concat(isItalic ? 'active' : ''),
    "aria-label": "Format Italics"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-italic"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'underline');
    },
    className: "btn btn-outline-secondary border-0 toolbar-item spaced ".concat(isUnderline ? 'active' : ''),
    "aria-label": "Format Underline"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-underline"
  })));
}